/**
 * Style Constants
 * Centralized constants for breakpoints, z-indexes, and reusable class strings
 */

export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
} as const

export const Z_INDEX = {
  dropdown: 40,
  overlay: 45,
  modal: 50,
  player: 100,
  toast: 110,
} as const

export const SPACING = {
  page: 'p-4 sm:p-6 lg:p-8',
  section: 'p-section',
  card: 'p-card',
  compact: 'p-compact',
} as const

export const TRANSITIONS = {
  base: 'transition-base',
  slow: 'transition-slow',
} as const

